import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

/**
 * Valid tone options for LexChat personality
 */
export type LexChatTone = 'gentle' | 'normal' | 'assertive' | 'drill_sergeant';

/**
 * Controls the visibility of the LexChat modal
 */
export const showLexChatAtom = atom(false);

/**
 * Allows external components to inject a prompt into LexChat
 */
export const injectLexPromptAtom = atom<string>('');

/**
 * Persists the user's selected chat tone preference
 */
export const lexChatToneAtom = atomWithStorage<LexChatTone>('lex_chat_tone', 'normal');

/**
 * Triggers focus on the text input (incremented to trigger useEffect)
 */
export const triggerTextInputFocusAtom = atom<number>(0);

/**
 * Tracks the active conversation ID for LotGPT chat sessions
 */
export const conversationIdAtom = atom<string | undefined>(undefined);
